import React from "react";
import { Quote } from "lucide-react";
import { BRAND } from "../../lib/constants";

export default function Dedication() {
    return (
        <section
            className="bg-[#FAF9F6] py-24 md:py-32 border-b border-stone-200"
            data-testid="dedication-section"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
                    <div className="md:col-span-4">
                        <div className="relative aspect-[4/5] overflow-hidden bg-stone-900">
                            <img
                                src={BRAND.principalPhoto}
                                alt={BRAND.principal}
                                className="absolute inset-0 w-full h-full object-cover"
                                loading="lazy"
                            />
                            {/* Dark gradient for caption legibility */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                            {/* Top badge */}
                            <div className="absolute top-5 left-5 bg-white/90 backdrop-blur-sm p-1.5 w-12 h-12 grid place-items-center">
                                <img
                                    src={BRAND.logo}
                                    alt="Momia logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            {/* Bottom caption */}
                            <div className="absolute bottom-6 left-6 right-6">
                                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/80 mb-2">
                                    Principal · Founder
                                </div>
                                <div className="font-cabinet font-bold text-white text-2xl leading-tight drop-shadow-md">
                                    {BRAND.principal}
                                </div>
                                <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-white/70">
                                    Momia Healthcare Exports
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-8">
                        <Quote
                            size={48}
                            strokeWidth={1.2}
                            className="text-[#4D7C0F] mb-6"
                        />
                        <blockquote className="font-cabinet font-normal text-3xl md:text-4xl lg:text-[42px] leading-[1.15] tracking-tight text-ink">
                            Healthcare is not a transaction — it's a{" "}
                            <span className="italic text-[#0C4A6E]">
                                dedication
                            </span>
                            . Every molecule we ship, every hospital we help
                            build, every Zoom call we take, carries the weight
                            of someone&apos;s health across an ocean.
                        </blockquote>
                        <div className="mt-10 flex items-center gap-4">
                            <div className="w-12 h-px bg-stone-400" />
                            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">
                                A note from our founder
                            </div>
                        </div>

                        <div className="mt-12 grid sm:grid-cols-3 gap-8">
                            <div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 mb-2">
                                    Meticulous
                                </div>
                                <p className="text-sm text-stone-700 leading-relaxed">
                                    Every batch verified against WHO-GMP &
                                    buyer-country regulatory dossiers before
                                    shipment.
                                </p>
                            </div>
                            <div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 mb-2">
                                    Dedicated
                                </div>
                                <p className="text-sm text-stone-700 leading-relaxed">
                                    Single point of contact per account — same
                                    person from RFQ to port-of-discharge.
                                </p>
                            </div>
                            <div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 mb-2">
                                    Pictorial
                                </div>
                                <p className="text-sm text-stone-700 leading-relaxed">
                                    Photographic QC reports, lot-traceable
                                    dossiers, and live shipment visibility for
                                    every consignment.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
